module.exports = __webpack_public_path__ + "img/send.7fc531a0.webp";